<template>
  <v-container>
    <!-- หมวดหมู่ใหม่ -->
    <v-container class="px-0" v-if="!MobileSize && !IpadSize">
      <h1 v-if="IpadSize" v-bind:style="{'font-size': '20px'}"><B>หมวดหมู่สินค้า</B></h1>
      <h1 v-else v-bind:style="{'font-size': '32px'}"><B>หมวดหมู่สินค้า</B></h1>
      <div class="text-xs-center">
        <VueSlickCarousel v-bind="settings" ref="carousel" v-if="datas.length !== 0" >
          <div v-for="(item, index) in  datas" :key="index" class="page_class " v-bind:style="{'cursor':'pointer'}">
            <!-- <a :href="'/UPS/banner/'+item.id+'&'+item.name+'&category_product&Allbrand&0&1'" @click.prevent> -->
              <v-card max-height="100%" max-width="100%" outlined class="px-0 cardHover" @click="GotoListProductCategory(item)">
                <v-card-text>
                  <v-row dense justify="center">
                    <v-col cols="12" align="center">
                      <v-img  v-if="item.category_logo_path !== null" :src="item.category_logo_path" loading="lazy" max-height="100%" max-width="100%"  width="84"  height="88" contain></v-img>
                      <v-img v-if="item.category_logo_path === null" src="@/assets/NoImage.png" loading="lazy"  width="84"  height="88" ></v-img>
                    </v-col>
                    <v-col cols="12" align="center">
                      <span class="textCategory">{{ item.category_name }}</span>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            <!-- </a> -->
          </div>
        </VueSlickCarousel>
      </div>
    </v-container>
    <span class="resposive_mobile" v-else>
      <h2 class="ml-3" style="font-weight: bold; font-size: 18px; line-height: 26px;"><B>หมวดหมู่สินค้า</B></h2>
      <div class=" text-xs-center Backgroundipad" v-if="IpadSize && !MobileSize">
        <VueSlickCarousel v-bind="settingresponsive" :arrows="true" ref="carousel" v-if="datas.length">
          <div align="center" v-for="(item, index) in  datas" :key="index" class="page_class " v-bind:style="{'background-color': '#FFFFFF','border':'2px solid #FAFAFA','cursor':'pointer'}">
            <!-- <div  v-bind:style="{'margin-Top': '5%','height':'200px' }" @click="call(item.name,item.id)" >
              <div  class="image_card">
              <v-img v-if="item.category_logo_path !== null" :src="item.category_logo_path" loading="lazy"  width="130px"  height="90px" ></v-img>
              <v-img v-if="item.category_logo_path === null" src="@/assets/NoImage.png" loading="lazy" width="80%"  height="100%" ></v-img>
              </div>
              <v-card-title  v-bind:style="{'margin-Top': '24px'}">
              <h6 class="two-lines ">{{item.name}}</h6>
              </v-card-title >
            </div> -->
            <v-card max-height="100%" max-width="100%" outlined class="px-0 cardHover" @click="GotoListProductCategory(item)">
              <v-card-text>
                <v-row dense justify="center">
                  <v-col cols="12" align="center">
                    <v-img  v-if="item.category_logo_path !== null" :src="item.category_logo_path" loading="lazy" max-height="100%" max-width="100%"  width="84"  height="88" contain></v-img>
                    <v-img v-if="item.category_logo_path === null" src="@/assets/NoImage.png" loading="lazy"  width="84"  height="88" ></v-img>
                  </v-col>
                  <v-col cols="12" align="center">
                    <span class="textCategory">{{ item.category_name }}</span>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </div>
        </VueSlickCarousel>
      </div>
      <div class="text-xs-center BackgroundMobile" v-else>
        <VueSlickCarousel v-bind="settingresponsive" :arrows="true" ref="carousel" v-if="datas.length">
          <div align="center" v-for="(item, index) in  datas" :key="index" class="page_class " v-bind:style="{'background-color': '#FFFFFF','border':'2px solid #FAFAFA','cursor':'pointer'}">
            <v-card max-height="100%" max-width="100%" outlined class="px-0 cardHover" @click="GotoListProductCategory(item)">
              <v-card-text>
                <v-row dense justify="center">
                  <v-col cols="12" align="center">
                    <v-img  v-if="item.category_logo_path !== null" :src="item.category_logo_path" loading="lazy" max-height="100%" max-width="100%"  width="84"  height="88" contain></v-img>
                    <v-img v-if="item.category_logo_path === null" src="@/assets/NoImage.png" loading="lazy"  width="84"  height="88" ></v-img>
                  </v-col>
                  <v-col cols="12" align="center">
                    <span class="textCategory">{{ item.category_name }}</span>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </div>
        </VueSlickCarousel>
      </div>
    </span>
    <!-- ร้านค้าใหม่ -->
    <v-row dense justify="center" class="mt-0 mb-4">
      <!-- <v-col cols="12" md="12" sm="12" xs="12">
        <v-img v-lazyload :src="require('@/assets/ImageINET-Marketplace/Banner/rsz_banner-3.jpg')" :lazy-src="require('@/assets/ImageINET-Marketplace/Banner/rsz_1banner-3.jpg')" height="100%" width="100%" contain></v-img>
      </v-col> -->
      <v-col cols="12" md="12" sm="12">
        <v-row style="margin: 0px 0px 0px 0px">
          <h1 v-if="IpadSize" v-bind:style="{'font-size': '20px'}"><B>ร้านค้า</B></h1>
          <h1 v-else :style="MobileSize ? 'font-size: 18px' : 'font-size: 32px'" class="pt-3"><B>ร้านค้า</B></h1>
          <v-spacer></v-spacer>
          <v-btn text @click="AllShop()" color="#27AB9C " class="mt-2 diaplayWeb px-0" plain style="font-weight: 600;">
            ร้านค้าทั้งหมด <v-btn height="24" width="24" fab x-small color="#DCFFDC" elevation="0" class="ml-0">
              <v-icon color="#008E00">mdi-chevron-right</v-icon>
            </v-btn>
          </v-btn>
          <v-btn text @click="AllShop()" color="#27AB9C" class="mt-2 displayIPAD px-0" plain style="font-weight: 600;">
            ร้านค้าทั้งหมด <v-btn height="24" width="24" fab x-small color="#DCFFDC" elevation="0" class="ml-0">
              <v-icon color="#008E00">mdi-chevron-right</v-icon>
            </v-btn>
          </v-btn>
          <v-btn text @click="AllShop()" color="#27AB9C" class="mt-2 displayMobile px-0" plain style="font-weight: 600;font-size: 14px;">
            ร้านค้าทั้งหมด <v-btn height="24" width="24" fab x-small color="#DCFFDC" elevation="0" class="ml-0">
              <v-icon color="#008E00">mdi-chevron-right</v-icon>
            </v-btn>
          </v-btn>
        </v-row>
      </v-col>
      <v-col cols="12" md="12" sm="12">
        <v-row dense>
          <v-col cols="6" md="2" sm="4" v-for="(itemShop, index) in productSearch" :key="index">
            <v-card width="100%" height="100%" v-if="index < 6" class="itemShop" style="cursor: pointer;" @click="gotoShopDetail(itemShop)">
              <v-card-text>
                <v-row dense justify="center">
                  <v-col cols="12" align="center">
                    <v-img  v-if="itemShop.shop_logo !== ''" :src="itemShop.shop_logo" loading="lazy"  width="84"  height="88" ></v-img>
                    <v-img v-if="itemShop.shop_logo === ''" src="@/assets/NoImage.png" loading="lazy"  width="84"  height="88" ></v-img>
                  </v-col>
                  <v-col cols="12" align="center">
                    <span class="textCategory">{{itemShop.shop_name}}</span>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- โปรโมชัน -->
    <!-- <v-row dense justify="center" class="mt-0 mb-4">
      <v-col cols="12" md="12" sm="12">
        <h1 v-if="IpadSize" v-bind:style="{'font-size': '20px'}"><B>โปรโมชัน</B></h1>
        <h1 v-else :style="MobileSize ? 'font-size: 18px' : 'font-size: 32px'"><B>โปรโมชัน</B></h1>
      </v-col>
      <v-col cols="6" md="4" sm="4" v-for="(item, index) in Promotion" :key="index" class="pr-4">
        <v-row dense>
          <v-card width="100%" height="100%" elevation="4" style="cursor: pointer;">
            <v-card-text class="pa-0" style="border-radius: 8px;">
              <v-img :src="item.img_promotion" width="100%" height="190" style="border-radius: 8px;"></v-img>
            </v-card-text>
          </v-card>
        </v-row>
      </v-col>
    </v-row> -->
    <!-- สั่งซื้ออีกครั้ง -->
    <v-row justify="center" class="mt-0" v-if="statusLogin === true">
      <v-col cols="12" md="12" sm="12" v-if="StatusHomeNewProduct">
        <v-row class="ma-0">
          <h1 v-if="IpadSize" v-bind:style="{'font-size': '20px'}"><B>สั่งซื้ออีกครั้ง</B></h1>
          <h1 v-else :style="MobileSize ? 'font-size: 18px' : 'font-size: 32px'"><B>สั่งซื้ออีกครั้ง</B></h1>
          <v-spacer style="border-top: 3px solid #EBEBEB; margin-top: 25px;" class="ml-4"></v-spacer>
          <v-btn text @click="AllBuyAgain()" color="#27AB9C " class="mt-2 diaplayWeb" plain style="font-weight: 600;">
            ดูทั้งหมด <v-btn height="24" width="24" fab x-small color="#DCFFDC" elevation="0" class="ml-2">
              <v-icon color="#008E00">mdi-chevron-right</v-icon>
            </v-btn>
          </v-btn>
          <v-btn text @click="AllBuyAgain()" color="#27AB9C" class="mt-2 displayIPAD" plain style="font-weight: 600;">
            ดูทั้งหมด <v-btn height="24" width="24" fab x-small color="#DCFFDC" elevation="0" class="ml-2">
              <v-icon color="#008E00">mdi-chevron-right</v-icon>
            </v-btn>
          </v-btn>
          <v-btn text @click="AllBuyAgain()" color="#27AB9C" class="mt-2 displayMobile" plain style="font-weight: 600; font-size: 14px;">
            ดูทั้งหมด <v-btn height="24" width="24" fab x-small color="#DCFFDC" elevation="0" class="ml-2">
              <v-icon color="#008E00">mdi-chevron-right</v-icon>
            </v-btn>
          </v-btn>
        </v-row>
        <div v-if="!MobileSize && !IpadSize">
          <vue-horizontal-list :items='BuyProductAgain' :options='options'>
            <template v-slot:nav-prev>
              <div><v-icon color="#008E00" size="32">mdi-chevron-left</v-icon></div>
            </template>

            <template v-slot:nav-next>
              <div><v-icon color="#008E00" size="32">mdi-chevron-right</v-icon></div>
            </template>
            <template v-slot:default='{ item }'>
              <a-skeleton :loading="check === true ? !loading : loading">
                <CardProducts :itemProduct='item' />
              </a-skeleton>
            </template>
          </vue-horizontal-list>
        </div>
        <div v-else>
          <v-row dense v-if="IpadSize && !MobileSize" class="px-0">
            <v-col cols="3" sm="3" xs="6" v-for="(item, index) in BuyProductAgain.slice(0, 12)" :key="index" class="mb-4">
              <CardProductsResponsive :itemProduct='item'/>
            </v-col>
          </v-row>
          <v-row dense v-else class="px-0">
            <v-col cols="6" sm="3" xs="6" v-for="(item, index) in BuyProductAgain.slice(0, 6)" :key="index" class="mb-4" >
              <CardProductsResponsive :itemProduct='item'/>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import { Encode, Decode } from '@/services'
export default {
  components: {
    VueSlickCarousel,
    CardProducts: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cardProduct-chunk" */ '@/components/Card/ProductCardUI'),
    CardProductsResponsive: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "cardProduct-chunk" */ '@/components/Card/ProductCardResponsive')
  },
  data () {
    return {
      settings: {
        infinite: false,
        slidesToShow: 10,
        speed: 900,
        rows: 2,
        slidesPerRow: 1,
        slidesToScroll: 10
      },
      settingresponsive: {
        infinite: false,
        slidesToShow: 2.5,
        speed: 900,
        rows: 2,
        slidesPerRow: 1,
        slidesToScroll: 2
      },
      options: {
        responsive: [
          { end: 576, size: 2 },
          { start: 576, end: 768, size: 2 },
          { start: 768, end: 992, size: 3 },
          { start: 992, end: 1200, size: 5 },
          { size: 6 }
        ],
        list: {
          // 1200 because @media (min-width: 1200px) and therefore I want to switch to windowed mode
          windowed: 1300,

          // Because: #app {padding: 80px 24px;}
          padding: 0
        },
        item: {
          // css class to inject into each individual item
          class: '',
          // padding between each item
          padding: 16
        },
        position: {
          // Start from '1' on mounted.
          start: 0
        }
      },
      productSearch: [],
      NoDataInSearch: false,
      datas: [],
      statusLogin: false,
      onedata: [],
      Promotion: [],
      BuyProductAgain: [],
      screendisplay: '',
      tokenstatus: '',
      dataRole: '',
      StatusHomeNewProduct: false,
      status: false,
      check: false,
      loading: true
    }
  },
  created () {
    this.screendisplay = screen.width
    this.$EventBus.$on('getBuyProductAgain', this.getBuyProductAgain)
    if (Object.prototype.hasOwnProperty.call(localStorage, 'oneData')) {
      this.onedata = []
      this.onedata = JSON.parse(Decode.decode(localStorage.getItem('oneData')))
      // console.log(this.onedata)
      if (this.onedata.user === undefined && this.onedata.user === '') {
        localStorage.removeItem('oneData')
      }
      if (this.onedata.user !== undefined) {
        // this.username = onedata.user[0].first_name_th + ' ' + onedata.user[0].last_name_th
        this.statusLogin = true
        // this.AuthorityUser()
      } else {
        this.statusLogin = false
      }
    } else {
      this.statusLogin = false
      this.checkButton = false
    }
    this.getData()
    this.getResultAllShop()
    this.getPromotion()
    this.getBuyProductAgain()
  },
  mounted () {
    // this.$EventBus.$on('getBuyProductAgain', this.getBuyProductAgain)

    // this.$on('hook:beforeDestroy', () => {
    //   this.$EventBus.$off('getBuyProductAgain')
    // })
  },
  methods: {
    AllShop () {
      this.$router.push({ path: '/allShop' }).catch(() => {})
    },
    AllBuyAgain () {
      this.$router.push({ path: '/buyAgain' }).catch(() => {})
    },
    GotoListProductCategory (item) {
      localStorage.setItem('category', Encode.encode(item))
      this.$router.push(`/ListProduct/${item.category_name}`).catch(() => {})
    },
    async getData () {
      // var datacategory = {
      //   role: 'ext_buyer',
      //   seller_shop_id: '16'
      // }
      this.datas = []
      await this.$store.dispatch('actionCategory')
      const response = await this.$store.state.ModuleShop.stateCategory
      console.log(response)
      if (response.result === 'SUCCESS') {
        this.datas = await response.data
      } else {
        this.datas = []
      }
    },
    async getResultAllShop () {
      var dataAllShop
      if (localStorage.getItem('roleUser') !== null && localStorage.getItem('oneData') !== null) {
        var dataRole = JSON.parse(localStorage.getItem('roleUser'))
        var companyId = ''
        if (localStorage.getItem('SetRowCompany') !== null) {
          companyId = JSON.parse(Decode.decode(localStorage.getItem('SetRowCompany')))
        }
        dataAllShop = {
          role_user: dataRole.role,
          company_id: companyId !== '' ? companyId.company.company_id : '-1',
          page: 1
        }
      } else {
        dataAllShop = {
          role_user: 'ext_buyer',
          company_id: '-1',
          page: 1
        }
      }
      await this.$store.dispatch('actionListAllShop', dataAllShop)
      var response = await this.$store.state.ModuleShop.stateListAllShop
      // console.log('Result Search ======>', response)
      if (response.code === 200) {
        this.productSearch = response.data.list_shop
      } else {
        this.productSearch = []
        this.NoDataInSearch = true
      }
    },
    gotoShopDetail (val) {
      const shopCleaned = val.shop_name.replace(/\s/g, '-')
      this.$router.push(`/shoppage/${shopCleaned}-${val.shop_id}`).catch(() => {})
    },
    getPromotion () {
      this.Promotion = []
      for (var i = 0; i < 3; i++) {
        this.Promotion.push({
          img_promotion: `https://picsum.photos/500/300?image=${i * 5 + 10}`
        })
      }
    },
    async getBuyProductAgain () {
      var companyID = ''
      this.BuyProductAgain = []
      if (localStorage.getItem('roleUser') !== null) {
        this.dataRole = JSON.parse(localStorage.getItem('roleUser'))
        if (localStorage.getItem('oneData') !== null) {
          this.tokenstatus = this.onedata.user.access_token
        } else {
          this.tokenstatus = ''
        }
      } else {
        this.dataRole = ''
        this.tokenstatus = ''
      }
      if (localStorage.getItem('SetRowCompany') !== null) {
        var companyDataSet = JSON.parse(Decode.decode(localStorage.getItem('SetRowCompany')))
        companyID = companyDataSet.company.company_id
      } else {
        companyID = '-1'
      }
      var data
      data = {
        role_user: this.dataRole !== '' ? this.dataRole.role : 'ext_buyer',
        company_id: companyID
      }
      await this.$store.dispatch('actionsGetBuyAgainProduct', data)
      var response = await this.$store.state.ModuleProductNode.stateBuyAgainProduct
      if (response.ok === 'y') {
        if (response.query_result.length !== 0) {
          this.BuyProductAgain = await [...response.query_result]
          // console.log('BuyProductAgain ===========>', this.BuyProductAgain)
          this.status = true
          this.check = true
          this.StatusHomeNewProduct = true
        } else {
          this.BuyProductAgain = 'ยังไม่มีรายการสินค้า'
          this.status = true
          this.check = true
          this.StatusHomeNewProduct = false
        }
      } else {
        this.BuyProductAgain = []
        this.status = true
        this.check = true
        this.StatusHomeNewProduct = false
      }
    }
  },
  computed: {
    MobileSize () {
      const { xs } = this.$vuetify.breakpoint
      return !!xs
    },
    IpadSize () {
      const { sm } = this.$vuetify.breakpoint
      return !!sm
    },
    IpadProSize () {
      const { md } = this.$vuetify.breakpoint
      return !!md
    }
  }
}
</script>

<style scoped>
.cardHover {
  transition: box-shadow .3s;
  margin: 0 auto;
}
.cardHover:hover {
  box-shadow: 0 0 12px rgba(33,33,33, 0.5);
  transform: scale(1);
}
.itemShop {
  position: relative;
  display: inline-block;
  transition: all 0.4s ease;
}
.itemShop:hover {
  transform: scale(1);
  box-shadow: 0 0 12px rgba(33,33,33, 0.5);
}
.textCategory {
  color: rgba(0,0,0,.8);
  font-size: .875rem;
  text-decoration: none;
  line-height: 1.25rem;
  height: 2.5rem;
  margin-bottom: 0.625rem;
  word-break: break-word;
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.container {
  max-width: 1250px;
}
</style>
<style scoped>
@media screen and (min-width: 360px) {
  .displayMobile {
    display: inline;
  }

  .displayIPAD {
    display: none;
  }

  .diaplayWeb {
    display: none;
  }
}

@media screen and (min-width: 768px) and (max-width: 1280px) {
  .displayIPAD {
    display: inline;
  }

  .displayMobile {
    display: none;
  }

  .diaplayWeb {
    display: none;
  }
}

@media screen and (min-width: 1280px) {
  .displayIPAD {
    display: none;
  }

  .displayMobile {
    display: none;
  }

  .diaplayWeb {
    display: inline;
  }
}
</style>

<style  lang="scss" scoped>
   .Background {
      padding-left: 2%;
      padding-right: 2%;
      padding-top: 32px;
   }
   .BackgroundMobile {
     padding-left: 5%;
     padding-right: 5%;
   }
   .Backgroundipad {
     padding-left: 2%;
     padding-right: 2%;
   }
   .image_card{
    padding-left:2%;
   }
   .page_class{
     justify-content: center;
   }
   .slick-slider {
     width: 100%;
    //  padding-left: 5px;
    //  padding-right: 5px;
     ::v-deep .slick-arrow:before {
        color: #d4fad4;
        font-size: 32px;
        height: 23px;
        background: #008E00;
        border-radius: 90%;
        display: flex;
        justify-content: center;
        align-items: center;
        -webkit-text-stroke: .1px #008E00;
     }
    }
    .resposive_mobile {
       padding-left: 40%;
    }
    .two-lines {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      white-space: normal;
      word-break: keep-all;
    }
</style>
